/**
 * Models a user role object
 */

import Brace from "backbone.brace";

const Model = Brace.Model.extend({
  namedAttributes: {
    id: Number,
    key: String,
    name: String,
    internalOnly: Boolean,
    // used by role selection screen
    checked: Boolean,
  },
  defaults: {
    checked: false,
  },
});

export { Model as default };
